import React from 'react'

export default function WantWork() {
  return (
    <>
    <section className="want_work_sec">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div
                className="heading"
                data-aos="fade-right"
                data-aos-duration="2500"
              >
                <h2>Want to work with us?</h2>
                <p>
                  Meeting the demand for skilled developers, facilitating
                  seamless recruitment processes to acquire top talent, enabling
                  innovation and project success
                </p>
                <ul className="ul_con">
                  <li>
                    <a href="">
                      <i className="ri-arrow-right-double-line"></i>WordPress
                      Developer
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <i className="ri-arrow-right-double-line"></i>Node JS
                      Developer
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <i className="ri-arrow-right-double-line"></i>iOS
                      Developer
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <i className="ri-arrow-right-double-line"></i>PHP
                      Developer
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <i className="ri-arrow-right-double-line"></i>React Native
                      Developer
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <i className="ri-arrow-right-double-line"></i>Android
                      Developer
                    </a>
                  </li>
                </ul>
                <div className="btn_sec">
                  <a href="" className="btn1">
                    Request A Quote
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
